// Discriminator carried in the `details` of the failed_precondition error
// thrown when an admin tries to edit or hard-delete a captured count on a
// building that is not yet `complete` (AE4 / ADR-022).
//
// The admin LWW conflict (update-capture-item.ts) ALSO surfaces as
// `failed_precondition` (Encore has no 409 status), carrying
// `details.authoritative`. So a client cannot tell the two apart by
// `err.code` alone — it keys off this `reason` to distinguish the
// completion gate from a stale-version conflict and render the right
// message ("mark the building complete first" vs "re-enter your change").

import type { BuildingStatus } from './building-status'

export const BUILDING_NOT_COMPLETE_REASON = 'building_not_complete'

export interface BuildingNotEditableDetails {
  reason: typeof BUILDING_NOT_COMPLETE_REASON
  buildingStatus: BuildingStatus
}
